import { useUser } from "shared/hooks/useAuth";
import { Actions } from "shared/types/actions";

const useRestrictedFeature = (featureList: Actions[]) => {
  const user = useUser();
  if (!user) return true;
  const actionList = user.actions.split(";") as Actions[];
  const hasFeature = featureList.some((feature) =>
    actionList.includes(feature)
  );
  return hasFeature;
};
export default useRestrictedFeature;
